import React from 'react'
import { FormattedMessage } from 'react-intl'
import { DateTime } from 'luxon'
import { isUndefined } from 'lodash-es'

import { CountdownComponent } from '../WebinarCountdown/WebinarCountdown'

import './ScheduleTimerComponent.scss'

interface ScheduleTimerComponentProps {
  startTimeEpoch?: number | string
  renderOnlyTimer?: boolean
  onLiveCountdownZero?: () => void
}

const ScheduleTimerComponent = ({
  startTimeEpoch,
  renderOnlyTimer,
  onLiveCountdownZero,
}: ScheduleTimerComponentProps) => {
  if (isUndefined(startTimeEpoch)) {
    return null
  }

  const countdown = (
    <CountdownComponent
      timestamp={startTimeEpoch}
      onCountdownZero={onLiveCountdownZero}
    />
  )

  const isPast = DateTime.fromSeconds(Number(startTimeEpoch)) < DateTime.now()

  return (
    <span className="schedule-timer-component">
      {renderOnlyTimer ? (
        <div className="icon-and-timer">{countdown}</div>
      ) : (
        <>
          {isPast ? (
            <FormattedMessage
              defaultMessage="Event was scheduled to be live {countdown}"
              values={{ countdown }}
            />
          ) : (
            <FormattedMessage
              defaultMessage="Event is scheduled to be live {countdown}"
              values={{ countdown }}
            />
          )}
        </>
      )}
    </span>
  )
}

export default ScheduleTimerComponent
